import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_GPIMG = gql`
  query MyQuery {
  gpExperiencePage {
    imageContainers {
      contentItems {
        ... on ImageContainer {
          title
          text
          image {
            urls
          }
          imageAltText
          imageOrientation
          enabled
        }
      }
    }
  }
}
`;

export async function fetchHero() {
  const response = await apolloClient.query({
    query: GET_GPIMG,
    fetchPolicy: "network-only",
  });

  return response.data;
}
